
const apiProxy = require('./apiProxy.js');
const stateManager = require('../../utils/state/stateManager.js');

export async function loadMenu()
{
    var state = stateManager.getStore().getState();
    var requestBody = {};
    requestBody.venueCode = state.venueCode; 
    requestBody.menuId = state.saleMenuId;
    requestBody.rewardMenuId = state.rewardMenuId;
    requestBody.storefrontId = state.storefront.id;
    requestBody.priceBandId = state.priceBandId;
    requestBody.dispatchType = state.basket.order.dispatchType;

    var serverResponse = await apiProxy.put("effectiveMenu", requestBody);
    return serverResponse;

}